import React, { useContext, useEffect, useRef, useState } from 'react'
import Popup from '../Popup/Popup'
import { SideNavigationGroupProps } from './SideNavigation.types'
import { SideNavigationContext } from './SideNavigation'
import Icon from '../Icon/Icon'
import { debug } from 'webpack'

const SideNavigationGroup: React.FC<SideNavigationGroupProps> = ({
    hideIfNoChildren,
    nullMessage,
    shortTitle,
    groupBaseUrl,
    id,
    title,
    children,
}) => {
    const ref = useRef(null)
    const { location, useDrawers, isCollapsed, nestGroups, selectedGroupId, setSelectedGroupId } = useContext(
        SideNavigationContext,
    )

    //@ts-ignore
    const [childPaths, setChildPaths] = useState(React.Children.map(children, (child) => child?.props?.path))
    const [showMenu, setShowMenu] = useState(false)
    const [openDrawer, setOpenDrawer] = useState(useDrawers ? false : true)
    const [isActive, setIsActive] = useState(false)
    const isSelected = selectedGroupId && selectedGroupId === id
    const [isRouteMatch, setIsRouteMatch] = useState(false)
    const _title = isCollapsed ? shortTitle : title

    const renderChildren = openDrawer && !isCollapsed && (!nestGroups || isSelected)

    const handleClick = (e) => {
        e.stopPropagation()
        setSelectedGroupId(id)
        if (useDrawers) {
            setOpenDrawer(!openDrawer)
        }
    }

    const handleSelect = (e) => {
        setSelectedGroupId(null)
        document.removeEventListener('click', handleSelect)
    }

    useEffect(() => {
        if (isCollapsed && isSelected) {
            document.addEventListener('click', handleSelect)
        }
    }, [isCollapsed, isSelected])
    useEffect(() => {
        if (groupBaseUrl && location && location.pathname.indexOf(groupBaseUrl) !== -1) {
            setIsActive(true)
        } else {
            setIsActive(false)
        }
    }, [location])

    useEffect(() => {
        let isMatch = false

        childPaths.forEach((path) => {
            if (location?.pathname?.indexOf(path) !== -1) {
                isMatch = true
            }
        })
        setIsRouteMatch(isMatch)
    }, [location])

    if (nestGroups && !isCollapsed) {
        if (selectedGroupId && selectedGroupId === id) {
            return (
                <div className='r-side-navigation-group'>
                    <div className='r-title' onClick={() => setSelectedGroupId(null)}>
                        <Icon type={'chevron-left'} />
                        {_title}
                    </div>
                    {children}
                </div>
            )
        }
    }

    if (nestGroups && selectedGroupId && !isCollapsed) {
        return null
    }

    const isNoChildren =
        children === undefined ||
        children === null ||
        children === '' ||
        (Array.isArray(children) && children.length === 0)

    if (isNoChildren && hideIfNoChildren) {
        return null
    }

    return (
        <div className={`r-side-navigation-group ${isRouteMatch || isSelected || isActive ? 'r-state-selected' : ''}`}>
            <div className='r-title' onClick={handleClick} ref={ref}>
                {_title}
                {useDrawers ? (
                    <Icon type={'chevron-down'} iconStyle={{ transform: `rotate(${openDrawer ? 180 : 0}deg)` }} />
                ) : null}
            </div>
            {/*{renderChildren ? children : null}*/}
            {isCollapsed || (nestGroups && selectedGroupId !== id) ? null : isNoChildren && nullMessage ? (
                <div className={'r-group-no-items-message'}>{nullMessage}</div>
            ) : (
                children
            )}
            {isCollapsed ? (
                <Popup
                    className={`r-side-navigation-container ${isCollapsed ? 'r-state-collapsed' : ''}`}
                    anchor={ref}
                    show={isCollapsed && isSelected}
                    pos={'right'}
                >
                    <div className={'r-sidenav-collapsed-items'}>{children}</div>
                </Popup>
            ) : null}
        </div>
    )
}

export default SideNavigationGroup
